<app-environment-decorator></app-environment-decorator>

<main class="Root">
	<!-- Dashboard loader -->
	<article
		*ngIf="!logged()"
		class="Spinner"
	>
		<mat-spinner
			[diameter]="300"
			color="primary"
		></mat-spinner>
	</article>

	<router-outlet />
</main>
